import React from "react";
import {useLoaderData, useParams} from "react-router-dom";
import OwnGroupsList from "../../components/groups/ownGroupsList";
import PageFrame from "../../components/pageFrame";
import API from "../../../api/api";
import CreateGroup from "../../components/groups/createGroup";
import EnterInviteCode from "../../components/groups/enterInviteCode";
import ShowInviteCode from "../../components/groups/showInviteCode";

function RootElement() {
    const data = useLoaderData();
    return <PageFrame pageName='page/groups'><OwnGroupsList memberships={data} /></PageFrame>;
}

function JoinCodeHelper() {
    const data = useLoaderData();
    const { code } = useParams();
    return <PageFrame pageName='page/group/join'><ShowInviteCode groupData={data} code={code} /></PageFrame>;
}

export const Routes = [
    { path: '', element: <RootElement />, loader: async() => await API.get('groups/getDecoratedMemberships') },
    { path: 'create', element: <PageFrame pageName='page/group/create'><CreateGroup /></PageFrame> },
    { path: 'join', element: <PageFrame pageName='page/group/join'><EnterInviteCode/></PageFrame> },
    { path: 'join/:code', element: <JoinCodeHelper />, loader: ({ params }) => API.getWithQuery('groups/invites/getGroupByCode', { inviteCode: params.code }) },
];
